import React, {Component} from "react";
import {Transition, animated} from 'react-spring/renderprops';

const pages = [
    style => (
      <animated.div style={{ ...style }}>3</animated.div>
    ),
    style => (
      <animated.div style={{ ...style }}>2</animated.div>
    ),
    style => (
      <animated.div style={{ ...style }}>1</animated.div>
    ),
    style => (
      <animated.div style={{ ...style }}>START</animated.div>
    ),
  ]

const audio = new Audio("https://www.soundjay.com/button/sounds/beep-08b.mp3")


class Gamefication extends Component{
    state={
        number : 0
    }
    
    componentDidMount = () => {
        audio.play()
        setTimeout(()=>{
            if (this.state.number < 3 ) {
                this.setState({number : this.state.number+1})
            }
        },1000)
    }
    componentDidUpdate = () => {
        audio.play()
        setTimeout(()=>{
            if (this.state.number < 3 ) {
                this.setState({number : this.state.number+1})
            } else {
            }
        },1000)
    }
    render() {
        return (<div className="main">
        <Transition
          native
        //   reset
        //   unique
          items={this.state.number}
          from={{ opacity: 0, fontSize: '50px' }}
          enter={{ opacity: 1, fontSize: '70px' }}
          leave={{ opacity: 0,fontSize: '30px' }}
          config={{ tension: 50, friction: 25 }}>
          {index => pages[index]}
        </Transition>
        <style jsx="true" scoped> {`
            .main {
                position: absolute;
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        
        
        `}

        </style>
      </div>
        )
    }
}

export default Gamefication;